import { render, staticRenderFns } from "./simple-modal.vue?vue&type=template&id=e6dc73b2&"
import script from "./simple-modal.vue?vue&type=script&lang=js&"
export * from "./simple-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports